import { formStateToJS, FormStateShape } from '@servicetitan/form-state';
import { FormState, ValidatableMapOrArray } from 'formstate';
import { keys } from '../../../utils/keys';

export interface PortalFilterValue<T> {
    count: number;
    values: T;
}

export const portalFilterIsValueEmpty = (val: any): boolean =>
    val === undefined || val === '' || (Array.isArray(val) && !val.length);

export const portalFilterHasAny = <T extends ValidatableMapOrArray>(
    state: FormState<T>
): boolean => {
    const data = formStateToJS(state);

    return keys(data).some(key => !portalFilterIsValueEmpty(data[key]));
};

export const portalFilterGetValue = <T extends ValidatableMapOrArray>(
    state: FormState<T>
): PortalFilterValue<FormStateShape<T>> => {
    const data = formStateToJS(state);

    return {
        count: keys(data).filter(key => !portalFilterIsValueEmpty(data[key])).length,
        values: data,
    };
};
